<template>
  <div class="about">
    <span class="cursor" @click="toUrl({url:'about','type':'2'})">隐私保护</span>
    <span class="fengefu">|</span>
    <span class="cursor" @click="toUrl({url:'about','type':'1'})">关于安博</span>
    <span class="fengefu">|</span>
    <span class="cursor" @click="toUrl({url:'about','type':'3'})">加盟合作</span>
    <span class="fengefu">|</span>
    <span class="cursor" @click="toUrl({url:'about','type':'4'})">联系我们</span>
    <div class="copy">版权所有©️2011 安博教育集团 保留所有权利 京ICP证041025号 
      <a href="https://beian.miit.gov.cn/" target="_blank">京ICP备10020550号-14</a> 网络国际联网单位备案号 京海淀分局1101081826</div>
  </div>
</template>

<script>
export default {
  name: 'copyBottom',
  methods: {
    toUrl(obj) {
      if (obj.type === '1') {
        window.open('https://www.ambow.com/');
        return;
      }
      this.$router.push({ path: 'about', query: { type: obj.type } });
    },
  },
};
</script>

<style scoped lang="stylus">
.fengefu {
  padding 0 10px;
}
.about {
  padding-top 43px
  padding-bottom 32px
  width: 100%;
  text-align center
  font-size: 10px;
  font-family: SegoeUI;
  color: #999999 ;
  line-height: 14px;
  margin: 0 auto
  .copy {
    padding-top 8px
    a {
      text-decoration: unset;
      color: #999999 
    }
  }
}
</style>
